import { useState, useEffect, useCallback } from "react"

const COOLDOWN_SECONDS = 60

type UseResendCooldownReturn = {
  canResend: boolean
  secondsRemaining: number
  startCooldown: () => void
  resetCooldown: () => void
}

export const useResendCooldown = (): UseResendCooldownReturn => {
  const [secondsRemaining, setSecondsRemaining] = useState(0)

  useEffect(() => {
    if (secondsRemaining <= 0) return

    const timer = setInterval(() => {
      setSecondsRemaining((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(timer)
  }, [secondsRemaining])

  const startCooldown = useCallback(() => {
    setSecondsRemaining(COOLDOWN_SECONDS)
  }, [])

  const resetCooldown = useCallback(() => {
    setSecondsRemaining(0)
  }, [])

  return {
    canResend: secondsRemaining === 0,
    secondsRemaining,
    startCooldown,
    resetCooldown
  }
}
